import { CurrencySlice } from 'store/currency/slice'

export const CurrencyActions = {
  ...CurrencySlice.actions,
}
